import { ERROR_TYPE } from './hooks/useConfirmation.decl';

export const ERROR_MESSAGES_MAPPER: { [error: string]: string } = {
  [ERROR_TYPE.INVITATION_EXPIRED]: 'confirm_invitation.errors.invitation_expired',
  [ERROR_TYPE.PASSWORD_TOO_SHORT]: 'app.form.errors.password.password_length',
  [ERROR_TYPE.PASSWORD_FORMAT]: 'app.form.errors.password.password_strength',
  [ERROR_TYPE.NETWORK]: 'app.errors.connection',
  [ERROR_TYPE.UNKNOWN]: 'app.errors.unknown',
};
